import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

interface Confirm {
  question: string;
  labelConfirm: string;
  labelDecline: string;
}

@Component({
  selector: 'iw-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {
  // Pregunta
  @Input() question: string;
  // Etiqueta para la respuesta afirmativa
  @Input() labelConfirm: string;
  // Etiqueta para la respuesta negativa
  @Input() labelDecline: string;
  // Respuesta seleccionada de la pregunta
  @Output() response: EventEmitter<boolean> = new EventEmitter<boolean>();
  // Subcipciones de eventos del modal
  private subscriptions: Subscription[] = [];
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Trigger para emitir las respuestas sin usar eventos
  private resolveRes: any;
  // Referencia al template de la modal
  @ViewChild('template') private template: TemplateRef<any>;

  constructor(private modalService: BsModalService) {}

  ngOnInit() {}

  open() {
    this.modalRef = this.modalService.show(this.template, { class: 'modal-sm' });
    this.subscriptions.push(
      this.modalService.onHidden.subscribe((_reason: string) => {
        this.decline();
      })
    );
  }

  new(config: Confirm): Promise<boolean> {
    this.question = config.question;
    this.labelConfirm = config.labelConfirm;
    this.labelDecline = config.labelDecline;
    const res = new Promise<boolean>(resolve => (this.resolveRes = resolve));
    this.open();
    return res;
  }

  private confirm(): void {
    this.modalRef.hide();
    this.response.emit(true);
    if (this.resolveRes) {
      this.resolveRes(true);
    }
  }

  private decline(): void {
    this.modalRef.hide();
    this.response.emit(false);
    if (this.resolveRes) {
      this.resolveRes(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/confirm/confirm.component.ts